import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex items-center" }
const _hoisted_2 = {
  key: 0,
  class: "pr-3"
}
const _hoisted_3 = {
  key: 1,
  class: "flex items-center justify-center ml-1 space-x-1"
}

import { User } from '@/typings/user';
import Tag from './Tag.vue';

interface Props {
  user: User;
  hideTags?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    user: null,
    hideTags: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.$slots.avatar)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "avatar")
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, _toDisplayString(__props.user.Name), 1),
    (__props.user.Tags && __props.user.Tags.length && !__props.hideTags)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.user.Tags, (t) => {
            return (_openBlock(), _createBlock(Tag, {
              key: `${__props.user.Name}_${t.Uuid}`,
              tag: t
            }, null, 8, ["tag"]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})